import React from "react";

const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dt = (v) => (v ? new Date(v).toLocaleString("pt-BR") : "—");

export const GroupsTable = ({ groups }) => (
  <section className="border border-[#EBE5DF] bg-white p-6 overflow-x-auto" data-testid="pc-groups-section">
    <h2 className="text-lg font-semibold mb-4">Histórico de PIX agrupados</h2>
    <table className="w-full text-sm" data-testid="pc-groups-table">
      <thead><tr className="text-left text-[11px] uppercase tracking-widest text-[#5C5A57]">
        <th className="py-2">Criado</th><th>Empresa</th><th>Cliente</th><th>Vencimento</th><th>Parcelas</th><th>Valor</th><th>Status MP</th><th>Conciliação</th>
      </tr></thead>
      <tbody>
        {groups.length === 0 && <tr><td colSpan={8} className="py-4 text-[#5C5A57]">Nenhum PIX agrupado emitido.</td></tr>}
        {groups.map((g) => (
          <tr key={g.id} className="border-t border-[#EBE5DF]" data-testid={`pc-group-row-${g.id}`}>
            <td className="py-2">{dt(g.created_at)}</td><td>{g.bu === "cris" ? "Cris Lingerie" : "Eletros"}</td>
            <td>{g.client_name || "—"}</td><td>{g.due_date}</td><td>{g.count}</td><td>{brl(g.amount)}</td>
            <td>{g.mp_status || g.status}{g.superseded_at ? " (substituído)" : ""}</td><td>{g.settlement_state || "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
);

export const WaiversTable = ({ items }) => (
  <section className="border border-[#EBE5DF] bg-white p-6 overflow-x-auto" data-testid="pc-waivers-section">
    <h2 className="text-lg font-semibold mb-1">Abatimentos de encargos por validade do PIX</h2>
    <p className="text-xs text-[#5C5A57] mb-4">Juros/multa acumulados entre a emissão e o pagamento de um PIX agrupado pago dentro da validade. O contrato e os encargos históricos não são alterados.</p>
    <table className="w-full text-sm" data-testid="pc-waivers-table">
      <thead><tr className="text-left text-[11px] uppercase tracking-widest text-[#5C5A57]">
        <th className="py-2">Registrado</th><th>Empresa</th><th>Parcela</th><th>Valor PIX</th><th>Saldo no pagamento</th><th>Abatimento</th><th>Validade</th>
      </tr></thead>
      <tbody>
        {items.length === 0 && <tr><td colSpan={7} className="py-4 text-[#5C5A57]">Nenhum abatimento registrado.</td></tr>}
        {items.map((w) => (
          <tr key={w.id} className="border-t border-[#EBE5DF]" data-testid={`pc-waiver-row-${w.id}`}>
            <td className="py-2">{dt(w.created_at)}</td><td>{w.segment}</td><td>{w.installment_id?.slice(0, 8)}</td>
            <td>{brl(w.snapshot?.amount)}</td><td>{brl(w.at_payment?.updated_total)}</td>
            <td data-testid={`pc-waiver-amount-${w.id}`}>{brl(w.amount)}</td><td>{dt(w.pix_expires_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
);

export const AuditList = ({ items, failures }) => (
  <section className="grid md:grid-cols-2 gap-6" data-testid="pc-audit-section">
    <div className="border border-[#EBE5DF] bg-white p-6">
      <h2 className="text-lg font-semibold mb-3">Auditoria de configuração</h2>
      <ul className="space-y-2 text-sm max-h-72 overflow-auto" data-testid="pc-audit-list">
        {items.length === 0 && <li className="text-[#5C5A57]">Sem alterações registradas.</li>}
        {items.map((a) => (
          <li key={a.id} className="border-b border-[#EBE5DF] pb-2">
            <b>{a.action}</b> {a.old ? `${a.old} → ${a.new}` : a.client_id || a.account || ""}
            <div className="text-[11px] text-[#5C5A57]">{dt(a.at)} · {a.user_email}{a.reason ? ` · ${a.reason}` : ""}</div>
          </li>
        ))}
      </ul>
    </div>
    <div className="border border-[#EBE5DF] bg-white p-6">
      <h2 className="text-lg font-semibold mb-3">Falhas de assinatura de webhook</h2>
      <ul className="space-y-2 text-sm max-h-72 overflow-auto" data-testid="pc-webhook-failures">
        {failures.length === 0 && <li className="text-[#5C5A57]">Nenhuma falha registrada.</li>}
        {failures.map((f) => (
          <li key={f.id} className="border-b border-[#EBE5DF] pb-2">
            <b>{f.reason}</b> · {f.endpoint} · {f.action}
            <div className="text-[11px] text-[#5C5A57]">{dt(f.created_at)} · modo {f.mode} · pagamento {f.mp_payment_id || "—"}</div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
